<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-if="!loading" my-2>
            <form @submit.prevent="update_reports" autocomplete="off">
                <v-layout row wrap>

                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-select v-model="reports.report_type" :items="report_types" item-text="name"
                            item-value="value" :label="$store.getters.lang.data.report_type" outlined class="mx-1" filled
                            required rounded>
                        </v-select>
                    </v-flex>



                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="reports.report_text"
                            :label="$store.getters.lang.data.report_text" outlined class="mx-1" filled required>
                        </v-text-field>
                    </v-flex>



                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn color="primary" rounded class="mx-1" type="submit" x-large>
                            {{$store.getters.lang.data.update_btn}}</v-btn>
                    </v-flex>
                </v-layout>
            </form>
        </v-container>

        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>

<script>
    import controller from './../../controller/reports'
    export default {
        data() {
            return {
                reports: {},
                id: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },

            }
        },
        computed: {
            report_types() {
                return [{
                        name: 'comment',
                        value: 'comment'
                    },
                    {
                        name: 'profile',
                        value: 'profile'
                    }
                ]
            }

        },
        methods: {
            get_reports() {
                this.loading = true
                controller.getOne(this.id).then(r => {
                    this.reports = r.data.row
                    this.loading = false
                }).catch(e => {
                    console.log(e);
                })
            },
            update_reports() {
                controller.update_reports(this.reports).then(r => {
                    if (r.data) {
                        this.snackbar = {
                            value: true,
                            text: 'Updated',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Not Updated',
                            color: 'error'
                        }
                    }
                })
            },

        },
        mounted() {
            this.id = this.$route.params.id
            this.get_reports()
        },
    }
</script>